import { useHistory } from 'react-router-dom';

import { MOVEMENT_LOGIN_PAGE } from '../../utils/env';

export type UseSingleLogout = () => {
  logOutUser: () => void;
};

const buildSLOPath = (): string => {
  const currentUrl = window.location.href;
  const encodedCurrentUrl = encodeURIComponent(currentUrl);
  const encodedAfterLogoutRedirectUri = encodeURIComponent(
    `${MOVEMENT_LOGIN_PAGE}?redirect_uri=${encodedCurrentUrl}`,
  );
  return `/authentication-manager/logout?afterLogoutRedirectUri=${encodedAfterLogoutRedirectUri}`;
};

export const useSingleLogout: UseSingleLogout = () => {
  const history = useHistory();
  return {
    logOutUser: () => history.push(buildSLOPath()),
  };
};
